// axios
import axios from "axios";
import store from "./store/store";
const baseURL = "";
const token = JSON.stringify(store.getters.getToken);

export default axios.create({
  baseURL: baseURL,
  // You can add your headers here
  headers: {
    Authorization: token,
  },
});
